<template>
  <div class="display-flex" :style="divStyle">
    <div class="display-flex stat-cake" :style="cakeStyle">
      <div style="font-size:100%;">
        {{ obj.val }}
      </div>
      <template v-if="obj.reference">
        <div v-if="obj.reference" class="separator"></div>
        <div style="font-size:80%;">
          {{ obj.reference }}
        </div>
      </template>
      <div v-else-if="obj.unit" style="font-size:70%;color:#666;margin-top:3px;">
        {{ obj.unit }}
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div v-html="obj.label" style="font-size:90%;text-align:center;">
    </div>
  </div>
</template>
<script>
export default {
  props: {
    obj: Object,
    scale: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      divStyle: {
        justifyContent: 'center',
        width: 'calc(33% - 20px)',
        fontSize: (20 * this.scale) + 'px',
        minWidth: (140 * this.scale) + 'px',
        margin: '10px'
      },
      cakeStyle: {
        borderColor: this.obj.color,
        height: (120 * this.scale) + 'px',
        width: (120 * this.scale) + 'px',
        minWidth: (120 * this.scale) + 'px'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.stat-cake {
  flex-direction: column;
  align-items:center;
  flex-wrap:nowrap;
  justify-content: center;
  padding: 5px;
  border-radius: 50%;
  border: 6px solid #fff;
  .separator {
    width: 90%;
    margin: 2px 0 4px 0;
    border-top: 2px solid #666;
  }
}
</style>
